import { captureAuthCallbackParams } from '@/Domain/utils/authCallbackParams';
import { rememberEmailLoginOnActivation } from '@/Domain/utils/lastLoginMethod';
import { stripLegacyBodyCredentials } from '@/Domain/utils/legacyBodyCredentials';
import {
  clearPendingVerificationEmailOnActivation,
  consumePendingVerificationEmailFromUrl,
} from '@/Domain/utils/pendingVerificationEmail';

stripLegacyBodyCredentials();
consumePendingVerificationEmailFromUrl();
clearPendingVerificationEmailOnActivation();
rememberEmailLoginOnActivation();
captureAuthCallbackParams();
